import FilterButtonGroup, {
    FilterMenu,
} from "components/common/FilterButtonGroup";
import { tiposDocumento } from "data/inutilizacao";
import { Form } from "react-bootstrap";

export interface InutilizacaoFilter {
    serie?: number;
    tipoDocumento?: number;
}

export default function InutilizacaoMenus({
    filters,
    onFilter,
}: {
    filters: InutilizacaoFilter;
    onFilter: (filter: InutilizacaoFilter) => void;
}) {
    const tipoDocumentoItems = tiposDocumento.map((tipo) => ({
        label: tipo.descricao,
        active: filters.tipoDocumento === tipo.id,
        onClick: () => onFilter({ ...filters, tipoDocumento: tipo.id }),
    }));

    const filterMenus: FilterMenu[] = [
        {
            label: "Tipo Documento",
            items: [
                {
                    label: "Todos",
                    active: filters.tipoDocumento === undefined,
                    onClick: () => onFilter({ ...filters, tipoDocumento: undefined }),
                },
                ...tipoDocumentoItems,
            ],
        },
    ];

    return (
        <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="position-static">
                <FilterButtonGroup menus={filterMenus} />
            </div>

            <div className="d-flex gap-2 align-items-center">
                <Form.Control
                    type="number"
                    placeholder="Série"
                    size="sm"
                    style={{ width: "100px" }}
                    value={filters.serie || ""}
                    onChange={(e) =>
                        onFilter({
                            ...filters,
                            serie: e.target.value ? Number(e.target.value) : undefined
                        })
                    }
                />
            </div>
        </div>
    );
} 